import { DataSheet } from '@lune-fe/dapi-models'
import { formatNumbers, IconButtonDropdownNew } from '@lune-fe/lune-ui-lib'
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined'
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined'
import { FC, useState } from 'react'
import { useNavigate } from 'react-router-dom'

const ImportsContextMenu: FC<{
    sheet: DataSheet
}> = ({ sheet }) => {
    const navigate = useNavigate()
    const [open, setOpen] = useState<boolean>(false)

    const quantity = sheet.quantity

    return (
        <IconButtonDropdownNew
            className={'context-menu'}
            sx={{ ...(open && { opacity: '1 !important' }) }}
            onToggle={(isOpen) => setOpen(isOpen)}
            menuAutoWidth
            icon={<MoreVertOutlinedIcon />}
        >
            <IconButtonDropdownNew.MenuItem
                icon={<CloudDownloadOutlinedIcon />}
                title={`Offset`}
                disabled={quantity === null}
                onClick={() =>
                    quantity !== null && navigate(`/order?amount=${formatNumbers(quantity, 2)}`)
                }
            />
        </IconButtonDropdownNew>
    )
}

export default ImportsContextMenu
